import {getCostCentersRq} from '@store/apiEndpoints/index';
import {CostCenterVM} from '@models/serverModels';
import {queryHookFactory} from '../utils';

export const useGetCostCentersVMQuery = queryHookFactory<null, CostCenterVM[]>(
  getCostCentersRq
);
